//borderColor: (theme) => console.log(theme),
const keyNames = {
  REUSABLE: "REUSABLE",
  apiErrors: "apiErrors",
  themeMode: "themeMode",
  apiMsg: "apiMsg",
  extra: "extra",
  isLoading: "isLoading",
  toastData: "toastData",
  isAuthenticated: "isAuthenticated",
  //End multiple
  forceLogOut: "forceLogOut",
  userData: "userData",
  allUsers: "allUsers",
  dashboardStats: "dashboardStats",
  userDetail: "userDetail",
  exportData: "exportData",
  businessCategories: "businessCategories",
  bulkUploadResult: "bulkUploadResult",
  attendeeTypes: "attendeeTypes",
};
export default keyNames;
